import { create } from 'zustand';
import { AutoplayABWizardStore, AutoplayABWizardStep, AutoplayABWizardData } from './types';

const initialSteps: AutoplayABWizardStep[] = [
  { id: 1, title: 'Variações', description: '', completed: false },
  { id: 2, title: 'Ordem', description: '', completed: false },
  { id: 3, title: 'Tráfego', description: '', completed: false },
];

const initialData: AutoplayABWizardData = {
  endDate: null,
  durationMode: 'manual',
};

export const useAutoplayABWizardStore = create<AutoplayABWizardStore>((set, get) => ({
  currentStep: 1,
  steps: initialSteps,
  data: initialData,

  setCurrentStep: (step: number) => {
    set({ currentStep: step });
  },

  nextStep: () => {
    const { currentStep, steps } = get();
    if (currentStep < steps.length) {
      set({ currentStep: currentStep + 1 });
    }
  },

  prevStep: () => {
    const { currentStep } = get();
    if (currentStep > 1) {
      set({ currentStep: currentStep - 1 });
    }
  },

  completeStep: (stepId: number) => {
    set((state) => ({
      steps: state.steps.map((step) =>
        step.id === stepId ? { ...step, completed: true } : step
      ),
    }));
  },

  setEndDate: (date: Date | null) => {
    set((state) => ({
      data: { ...state.data, endDate: date },
    }));
  },

  setDurationMode: (mode: 'manual' | 'automatic') => {
    set((state) => ({
      data: { ...state.data, durationMode: mode },
    }));
  },

  reset: () => {
    set({
      currentStep: 1,
      steps: initialSteps.map((s) => ({ ...s, completed: false })),
      data: initialData,
    });
  },
}));
